// Төслийн дэлгэрэнгүй (v0.1): нил ягаан толгой (төсөл, огноо, тайлбар, хөтөч багш, хичээлүүд), төслөөр хүрэх үр дүн,
// суралцахуйн зорилтууд (СҮД, хүүхдийн одоогийн түвшин), 7 хоногийн хуваарь (өдөр бүр), гэртээ хэрхэн дэмжих.
import React, { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { Spin } from "antd";
import { FiArrowLeft } from "react-icons/fi";
import { instance } from "utils/axios";
import { DAY, md, dow } from "./shared";
import { Dots, LEVEL4 } from "./Subjects";

export default function ProjectPage() {
  const { id } = useParams();
  const [params] = useSearchParams();
  const c = params.get("c");
  const [p, setP] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => {
    instance({ method: "get", url: `/student/elem/${c}/project/${id}` }).then((r) => setP(r.data)).catch((e) => setErr(e?.response?.data?.error || "Төсөл олдсонгүй"));
  }, [id, c]);
  if (err) return <div className="pt-7 max-w-[1180px] mx-auto"><section className="tj-card p-6 text-sm text-[#6e5e8a]">{err}</section></div>;
  if (!p) return <div className="flex justify-center py-16"><Spin /></div>;
  const lead = p.teachers.find((t) => !/туслах/i.test(t.position || "")) || p.teachers[0];

  return (
    <div className="pt-3.5 md:pt-7 pb-6 md:pb-14 max-w-[1180px] mx-auto flex flex-col gap-3.5 md:gap-5">
      <Link to="/child" className="inline-flex items-center gap-2 text-primary font-bold text-[15px] self-start"><FiArrowLeft /> Хүүхэд</Link>
      <section className="rounded-[18px] md:rounded-[20px] p-5 md:px-8 md:py-8 text-white flex flex-wrap gap-5 items-end" style={{ background: "#5c1090" }}>
        <div className="flex-[1_1_420px] min-w-0">
          <div className="text-[11px] md:text-xs font-bold tracking-[0.12em] uppercase text-[#f2cd30]">{p.no ? `${p.no}-р төсөл · ` : ""}{md(p.startDate)} – {md(p.endDate)}</div>
          <h1 className="m-0 mt-1 text-3xl md:text-[44px] font-extrabold uppercase tracking-[-0.02em] leading-[1.05]">{p.name}.</h1>
          {p.goal && <p className="m-0 mt-3 text-[15px] md:text-base text-[#e5d8f5] leading-relaxed max-w-[620px]">{p.goal}</p>}
        </div>
        <div className="flex flex-wrap gap-3">
          {lead && <div className="rounded-xl bg-white/[.12] px-4 py-3"><div className="text-xs text-[#e5d8f5]">Хөтөч багш</div><div className="font-bold">{lead.firstName}</div></div>}
          {p.subjects.length > 0 && <div className="rounded-xl bg-white/[.12] px-4 py-3"><div className="text-xs text-[#e5d8f5]">Хичээл</div><div className="font-bold">{p.subjects.join(" · ")}</div></div>}
        </div>
      </section>

      <div className="flex flex-wrap gap-3.5 md:gap-5 items-start">
        <section className="tj-card px-4 py-5 md:p-6 flex-[1_1_420px] min-w-0">
          <h2 className="m-0 text-xl md:text-[22px] font-bold">Төслөөр хүрэх үр дүн</h2>
          <div className="text-sm text-[#6e5e8a] mb-2">7 хоногийн төгсгөлд хүүхэд эдгээрийг хийсэн байна</div>
          {!p.deliverables.length ? <p className="m-0 text-sm text-[#6e5e8a] pt-2">Багш оруулаагүй байна.</p> : p.deliverables.map((x, i) => (
            <div key={x.id} className="flex gap-3 py-3.5 border-t border-[#efedf4]">
              <span className="h-8 w-8 rounded-full bg-[#f3eeff] text-primary font-extrabold text-sm flex items-center justify-center shrink-0">{i + 1}</span>
              <span className="text-[15px] md:text-base font-semibold leading-snug pt-1">{x.text}</span>
            </div>
          ))}
        </section>
        <section className="tj-card px-4 py-5 md:p-6 flex-[1_1_420px] min-w-0">
          <h2 className="m-0 text-xl md:text-[22px] font-bold">Суралцахуйн зорилтууд</h2>
          <div className="text-sm text-[#6e5e8a] mb-2">Энэ төслөөр хамрах хичээлийн зорилтууд</div>
          {!p.outcomes.length ? <p className="m-0 text-sm text-[#6e5e8a] pt-2">Багш оруулаагүй байна.</p> : p.outcomes.map((o) => (
            <div key={o.id} className="py-3.5 border-t border-[#efedf4] flex items-center gap-3">
              <span className="flex-1 min-w-0">
                <span className="block text-sm font-bold text-primary">{o.subject} {o.code}</span>
                <span className="block text-[15px] leading-snug">{o.text}</span>
              </span>
              {o.level ? <><Dots v={o.level} /><b className="w-4 text-right">{o.level}</b></> : <span className="text-xs text-[#6e5e8a]">үнэлээгүй</span>}
            </div>
          ))}
          {p.outcomes.length > 0 && <div className="pt-3 text-xs text-[#6e5e8a] border-t border-[#efedf4]">{LEVEL4.slice(1).map((l, i) => `${i + 1} ${l}`).join(" · ")}</div>}
        </section>
      </div>

      <section className="tj-card px-4 py-5 md:p-6">
        <h2 className="m-0 text-xl md:text-[22px] font-bold">7 хоногийн хуваарь</h2>
        <div className="text-sm text-[#6e5e8a] mb-4">Өдөр бүр юу хийх вэ</div>
        <div className="grid gap-3" style={{ gridTemplateColumns: "repeat(auto-fit, minmax(190px, 1fr))" }}>
          {p.days.map((d) => (
            <div key={d.date} className={`rounded-2xl border p-4 flex flex-col gap-2 ${d.state === "today" ? "border-2 border-primary bg-[#f7f2ff]" : "border-[#e9e8f0] bg-white"}`}>
              <div className="flex items-baseline justify-between gap-2 text-[13px] font-bold text-[#6e5e8a]">
                <span>{DAY[dow(d.date)]} · {md(d.date)}</span>
                {d.state === "done" && <span className="text-[11px] tracking-wide uppercase text-[#15803d]">дууссан</span>}
                {d.state === "today" && <span className="text-[11px] tracking-wide uppercase text-primary">өнөөдөр</span>}
              </div>
              <div className="text-base font-extrabold leading-snug">{d.title || "—"}</div>
              {d.summary && <div className="text-sm text-[#6e5e8a] leading-relaxed whitespace-pre-line">{d.summary}</div>}
            </div>
          ))}
        </div>
      </section>

      {p.tips?.length > 0 && (
        <section className="rounded-[18px] md:rounded-[20px] border border-[#f2d675] bg-[#fff8db] px-4 py-5 md:p-7 flex flex-wrap gap-5">
          <div className="flex-[1_1_260px]">
            <div className="text-[11px] font-bold tracking-[0.12em] uppercase text-[#7a5a00]">Гэртээ</div>
            <h2 className="m-0 text-xl md:text-2xl font-extrabold">Энэ 7 хоногт хэрхэн дэмжих вэ</h2>
          </div>
          <ol className="flex-[2_1_420px] m-0 pl-5 flex flex-col gap-2 text-[15px]">
            {p.tips.map((t) => <li key={t.id}><Link to={`/todo/${t.id}`} className="text-[#1c1c1c] hover:text-primary">{t.title}</Link></li>)}
          </ol>
        </section>
      )}
    </div>
  );
}
